import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-166" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-167" data-mp="13vjfeisceqx1">
        <h2 className="text-center font-display text-[1.3rem] font-bold uppercase leading-tight text-navy sm:text-[1.9rem]" data-id="element-168" data-mp="18umjo10i0t3y">
          DOES THIS SOUND FAMILIAR?
        </h2>
        <p className="mt-1 text-center text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-169" data-mp="1dmw79ae55h32">
          You study surgical instruments—but when several clamps, forceps, scissors, retractors, or
          needle holders look almost identical, remembering the correct name can become frustrating.
        </p>
        <div className="mt-2 divide-y divide-navy/10 border-y border-navy/10" data-id="element-170" data-mp="1rj1b2peqa95a">
          {painPoints.map(p => <div key={p.title} className="border-l-4 border-clinical py-2 pl-2.5" data-id="element-171" data-mp="3tch1bl6wllzq">
              <h3 className="font-heading text-[0.76rem] font-extrabold uppercase leading-tight text-navy sm:text-[0.95rem]" data-id="element-172" data-mp="3tek2n1dib1jr">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] sm:text-[0.9rem]" data-id="element-173" data-mp="2ih7z3vww3xvb">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}